var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35899 6.66634C7.62261 6.66634 7.02566 7.2633 7.02566 7.99968C7.02566 8.73605 7.62261 9.33301 8.35899 9.33301C9.09537 9.33301 9.69232 8.73605 9.69232 7.99968C9.69232 7.2633 9.09537 6.66634 8.35899 6.66634Z",
    fill: "#234596"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35899 1.33333C7.62261 1.33333 7.02566 1.93029 7.02566 2.66667C7.02566 3.40305 7.62261 4 8.35899 4C9.09537 4 9.69232 3.40305 9.69232 2.66667C9.69232 1.93029 9.09537 1.33333 8.35899 1.33333Z",
    fill: "#234596"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35899 11.9998C7.62261 11.9998 7.02566 12.5968 7.02566 13.3332C7.02566 14.0695 7.62261 14.6665 8.35899 14.6665C9.09537 14.6665 9.69232 14.0695 9.69232 13.3332C9.69232 12.5968 9.09537 11.9998 8.35899 11.9998Z",
    fill: "#234596"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMzU4OTkgNi42NjYzNEM3LjYyMjYxIDYuNjY2MzQgNy4wMjU2NiA3LjI2MzMgNy4wMjU2NiA3Ljk5OTY4QzcuMDI1NjYgOC43MzYwNSA3LjYyMjYxIDkuMzMzMDEgOC4zNTg5OSA5LjMzMzAxQzkuMDk1MzcgOS4zMzMwMSA5LjY5MjMyIDguNzM2MDUgOS42OTIzMiA3Ljk5OTY4QzkuNjkyMzIgNy4yNjMzIDkuMDk1MzcgNi42NjYzNCA4LjM1ODk5IDYuNjY2MzRaIiBmaWxsPSIjMjM0NTk2Ii8+CjxwYXRoIGQ9Ik04LjM1ODk5IDEuMzMzMzNDNy42MjI2MSAxLjMzMzMzIDcuMDI1NjYgMS45MzAyOSA3LjAyNTY2IDIuNjY2NjdDNy4wMjU2NiAzLjQwMzA1IDcuNjIyNjEgNCA4LjM1ODk5IDRDOS4wOTUzNyA0IDkuNjkyMzIgMy40MDMwNSA5LjY5MjMyIDIuNjY2NjdDOS42OTIzMiAxLjkzMDI5IDkuMDk1MzcgMS4zMzMzMyA4LjM1ODk5IDEuMzMzMzNaIiBmaWxsPSIjMjM0NTk2Ii8+CjxwYXRoIGQ9Ik04LjM1ODk5IDExLjk5OThDNy42MjI2MSAxMS45OTk4IDcuMDI1NjYgMTIuNTk2OCA3LjAyNTY2IDEzLjMzMzJDNy4wMjU2NiAxNC4wNjk1IDcuNjIyNjEgMTQuNjY2NSA4LjM1ODk5IDE0LjY2NjVDOS4wOTUzNyAxNC42NjY1IDkuNjkyMzIgMTQuMDY5NSA5LjY5MjMyIDEzLjMzMzJDOS42OTIzMiAxMi41OTY4IDkuMDk1MzcgMTEuOTk5OCA4LjM1ODk5IDExLjk5OThaIiBmaWxsPSIjMjM0NTk2Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };